import axiosInstance from "../axiosInstance";

export const obtenerPostventasActivos = async (adminId) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/postventa-obtenerPostventasActivos`,
    {
      adminId,
    }
  );
};
